"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessInstanceWithTwoInvoices = void 0;
exports.ProcessInstanceWithTwoInvoices = {
    tenantId: {
        uuid: "b5f41b81-a75c-40cc-a8cb-5cad2aff35cb"
    },
    healthSystemTenantId: {
        uuid: "5a47d569-c0fe-4293-8bdc-56b21f6094bc"
    },
    guid: {
        uuid: "359dcf3c-5392-4440-8357-6c0b223b900f"
    },
    serviceLine: "IPC",
    caseType: "STANDALONE",
    gender: null,
    dateOfBirth: "1948-07-16",
    age: 75,
    hl7InsurancePayerId: "2001",
    hl7InsurancePlanId: "2001003",
    cmxInsurancePayerId: null,
    status: "NEW",
    sharedDiagnosisCodes: [],
    errors: [],
    invoices: [
        {
            type: "assembled",
            guid: "17cbbe28-bacb-4cc3-8fb7-52f9dc4601e2",
            date_of_service: "2023-08-31",
            datetime_of_service: "2023-08-31 11:00:00 EDT",
            department_code: "1010010072",
            department: {
                code: "1010010072",
                name: "DETC UROLOGY"
            },
            patient_type: "OUTPATIENT",
            billing_location: "HFH",
            billing_area: null,
            fee_schedule: null,
            division: "DETC UROLOGY",
            facility: "HFH",
            billing_provider_type: "Physician",
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: "Physician",
            filler_number: {
                number: null,
                issuer: null,
                type: null
            },
            billing_provider_name: "PEABODY, JAMES",
            billing_provider_number: {
                number: "H2149",
                issuer: "EPIC",
                type: "PROVID"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            referring_provider_name: "PEABODY, JAMES",
            referring_provider_number: {
                number: "H2149",
                issuer: "EPIC",
                type: "PROVID"
            },
            performing_provider_name: "PEABODY, JAMES",
            performing_provider_number: {
                number: "H2149",
                issuer: "EPIC",
                type: "PROVID"
            },
            transactions: [
                {
                    guid: "7ad1c2f4-1aa4-4628-862e-75e62f921355",
                    sequence_number: 1,
                    source_transaction_id: null,
                    deleted: false,
                    technical_code: null,
                    procedure: {
                        procedure_code: "99466",
                        units: 1.0,
                        sequence_number: null,
                        additionalProperties: undefined,
                        evidence: [],
                        custom_cpt: false
                    },
                    mapped_procedure: null,
                    modifiers: [],
                    diagnoses: [],
                    fee_schedule: null,
                    place_of_service: "DETC UROLOGY"
                }
            ],
            deleted: false,
            health_plan_id: null,
            billing_provider_credentials: "MD",
            performing_provider_credentials: "MD"
        },
        {
            type: "assembled",
            guid: "b5e51721-7adf-4371-848e-8f53f08d584c",
            date_of_service: "2024-08-20",
            datetime_of_service: "2024-08-20 00:00:00 EDT",
            department_code: "1120010045",
            department: {
                code: "1120010045",
                name: "HFJH ED"
            },
            patient_type: "EMERGENCY",
            billing_location: "HFM",
            billing_area: null,
            fee_schedule: null,
            division: "HFJH ED",
            facility: "HFM",
            billing_provider_type: "Hospitalist",
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: "Hospitalist",
            filler_number: {
                number: null,
                issuer: null,
                type: null
            },
            billing_provider_name: "WATSON, PETER",
            billing_provider_number: {
                number: "H9215",
                issuer: "EPIC",
                type: "PROVID"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            referring_provider_name: "REFERRAL, SELF",
            referring_provider_number: {
                number: "G33333",
                issuer: "EPIC",
                type: "PROVID"
            },
            performing_provider_name: "WATSON, PETER",
            performing_provider_number: {
                number: "H9215",
                issuer: "EPIC",
                type: "PROVID"
            },
            transactions: [
                {
                    guid: "1a6cceaf-6936-4cc0-9b36-5f94f5e6e288",
                    sequence_number: 1,
                    source_transaction_id: null,
                    deleted: false,
                    technical_code: null,
                    procedure: {
                        procedure_code: "99466",
                        units: 1.0,
                        sequence_number: null,
                        custom_cpt: false,
                        time_based: false,
                        add_on_code_available: false,
                        total_time: null,
                        medicare_time_rules: false,
                        add_on_code_id: null,
                        add_on_code_transaction_id: null,
                        evidence: [],
                        additionalProperties: {
                            id: 911040
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "99466",
                        units: 1.0,
                        sequence_number: 1,
                        custom_cpt: false,
                        active: true,
                        time_based: false,
                        add_on_code_available: false,
                        total_time: null,
                        medicare_time_rules: false,
                        add_on_code_id: null,
                        add_on_code_transaction_id: null,
                        evidence: [],
                        additionalProperties: {
                            id: 911041
                        }
                    },
                    modifiers: [
                        {
                            modifier_code: "NS",
                            modifier_type: "PRO",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 92086
                            }
                        }
                    ],
                    diagnoses: [
                        {
                            diagnosis_code: "R52",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 861409
                            },
                            shared: false,
                            active: true
                        }
                    ],
                    fee_schedule: null,
                    place_of_service: "HFJH ED"
                }
            ],
            deleted: false,
            health_plan_id: null,
            billing_provider_credentials: "MD",
            performing_provider_credentials: "MD"
        }
    ],
    isChargeable: false,
    qaStatus: null,
    caseUid: "1446e849-e9a0-4f46-9a65-b8217f8cf4b8",
    documentImprovements: [],
    cancelled: false,
    autoCancelled: false
};
//# sourceMappingURL=two-invoices.js.map